<template>
  <div class="ml-10 flex items-center space-x-4">
    <router-link :to="{name: 'podcast.show'}" class="router-link">
      Podcast
    </router-link>
    <router-link :to="{name: 'practices.list'}" class="router-link">
      Methoden
    </router-link>
    <router-link :to="{name: 'experiments.list'}" class="router-link">
      Experimente
    </router-link>
    <NoticeTrial />
    <NoticeBasic />
  </div>
</template>

<style scoped>
.router-link
{
  @apply flex flex-row items-center px-3 py-2;
  @apply rounded-md text-sm font-medium;
  @apply text-gray-300;
  @apply hover:bg-gray-900 hover:text-white;
}

.router-link-active
{
  @apply bg-gray-900 !important;
  @apply text-white !important;
}
</style>
